import * as React from "react";

import "./Tag.scss"

const Tag = ({ text, color = '', textColor = '' }) => {
    return (
        <div className="tag" style={{
            backgroundColor: color,
            color: textColor
        }}>
            {text}
        </div>
    );
};

export default Tag;